/**
 * Infrastruktura (/core/mesh) — čistý ModuleWorkspace (jako docker/containers).
 * Žádný ModulePage TopBar/Containers — jen catalog taby + WidgetPanel chrome
 * (NodePicker, Odemknout, DnD). Fleet tab = multi-widget (role + topology + uzly).
 * Ostatní taby = stávající panely beze ztráty.
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('mesh');

export default function MeshPage() {
  return <ModuleWorkspace def={DEF} defaultTab='infra' />;
}
